export default "__VITE_ASSET__BAbMHPSP__"